import { render, staticRenderFns } from "./e-chip-label.vue?vue&type=template&id=75c907ae&scoped=true&lang=pug"
import script from "./e-chip-label.vue?vue&type=script&lang=js"
export * from "./e-chip-label.vue?vue&type=script&lang=js"
import style0 from "./e-chip-label.vue?vue&type=style&index=0&id=75c907ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c907ae",
  null
  
)

export default component.exports